const updateState = (pets, updatedPet, internalStateSetter, outlet, petIndex) => {
    internalStateSetter({ pet: updatedPet })

    const updatedPets = pets.map((item, i) => {
        if (i === petIndex) return updatedPet;
        return item
    })

    outlet({ pets: updatedPets })
}



export default {
    'Pet.PetsForm.Name': ({ pets, pet, petIndex, value }, outlet, internalStateSetter) => {
        const updatedPet = { ...pet, name: value, nameError: '', hasError: false  }
        updateState(pets, updatedPet, internalStateSetter, outlet, petIndex, petIndex)
    },
    'Pet.PetsForm.Type': ({ pets, pet, petIndex, value }, outlet, internalStateSetter) => {
        const updatedPet = { ...pet, type: value, typeError: '', hasError: false  }
        updateState(pets, updatedPet, internalStateSetter, outlet, petIndex)
    },
    'Pet.PetsForm.Breed': ({ pets, pet, petIndex, value }, outlet, internalStateSetter) => {
        const updatedPet = { ...pet, breed: value, breedError: '', hasError: false  }
        updateState(pets, updatedPet, internalStateSetter, outlet, petIndex)
    },
    'Pet.PetsForm.Weight': ({ pets, pet, petIndex, value }, outlet, internalStateSetter) => {
        const updatedPet = { ...pet, weight: value, weightError: '', hasError: false  }
        updateState(pets, updatedPet, internalStateSetter, outlet, petIndex)
    },
    'Pet.PetsForm.DeleteButton': ({ resourceList: pets, petIndex, }, outlet) => {
        const filteredPets = pets.filter((_, i) => i !== petIndex)
        outlet({ pets: filteredPets })
    }
}
